import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { supabaseUrl, supabaseAnonKey } from '../../lib/supabase'

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [submitted, setSubmitted] = useState(false)
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setBusy(true)
    try {
      const url = `${supabaseUrl.replace(/\/$/, '')}/functions/v1/user-auth-forgot-password`
      const res = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          apikey: supabaseAnonKey,
        },
        body: JSON.stringify({ email: email.trim().toLowerCase() }),
      })
      if (!res.ok) {
        const data = await res.json().catch(() => ({}))
        throw new Error(data.error || `Request failed (${res.status})`)
      }
    } catch (err) {
      setBusy(false)
      setError(err.message || 'Something went wrong. Please try again.')
      return
    }
    setBusy(false)
    setSubmitted(true)
  }

  const inputStyle = {
    width: '100%',
    padding: '12px 16px',
    borderRadius: '8px',
    border: '2px solid #374151',
    backgroundColor: '#111827',
    color: 'white',
    fontSize: '16px',
    outline: 'none',
    boxSizing: 'border-box',
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundColor: '#111827',
        backgroundImage: 'radial-gradient(ellipse at 50% 0%, rgba(250,204,21,0.08) 0%, transparent 60%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
      }}
    >
      <div
        style={{
          backgroundColor: '#1f2937',
          borderRadius: '16px',
          border: '1px solid rgba(255,255,255,0.07)',
          padding: '40px',
          width: '100%',
          maxWidth: '400px',
          boxShadow: '0 25px 50px -12px rgba(0,0,0,0.5)',
        }}
      >
        {submitted ? (
          <div style={{ textAlign: 'center' }}>
            <div
              style={{
                width: 56,
                height: 56,
                borderRadius: '50%',
                backgroundColor: 'rgba(250,204,21,0.15)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 20px',
              }}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#FACC15" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6"/>
              </svg>
            </div>
            <h1 style={{ color: 'white', fontSize: '22px', fontWeight: '700', margin: '0 0 10px' }}>
              Check your inbox
            </h1>
            <p style={{ color: '#9ca3af', fontSize: '14px', margin: '0 0 24px', lineHeight: 1.6 }}>
              If <strong style={{ color: '#e5e7eb' }}>{email}</strong> is registered, a password reset link has been sent. Check your spam folder if you don't see it.
            </p>
            <Link
              to="/login"
              style={{ color: '#FACC15', fontSize: '14px', fontWeight: '600', textDecoration: 'none' }}
            >
              Back to sign in
            </Link>
          </div>
        ) : (
          <>
            <div style={{ marginBottom: '28px' }}>
              <h1 style={{ color: 'white', fontSize: '22px', fontWeight: '700', margin: '0 0 8px' }}>
                Forgot your password?
              </h1>
              <p style={{ color: '#9ca3af', fontSize: '14px', margin: 0 }}>
                Enter your email and we'll send you a reset link.
              </p>
            </div>

            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '16px' }}>
                <label style={{ display: 'block', color: '#9ca3af', fontSize: '14px', marginBottom: '6px' }}>
                  Email address
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  required
                  autoFocus
                  style={inputStyle}
                  onFocus={(e) => { e.target.style.borderColor = '#FACC15' }}
                  onBlur={(e) => { e.target.style.borderColor = '#374151' }}
                />
              </div>

              {error && (
                <p style={{ color: '#ef4444', fontSize: '14px', margin: '0 0 16px', textAlign: 'center' }}>
                  {error}
                </p>
              )}

              <button
                type="submit"
                disabled={busy}
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  borderRadius: '8px',
                  border: 'none',
                  backgroundColor: busy ? '#a16207' : '#FACC15',
                  color: '#111827',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: busy ? 'not-allowed' : 'pointer',
                  transition: 'background-color 0.15s',
                  marginBottom: '16px',
                }}
                onMouseEnter={(e) => { if (!busy) e.target.style.backgroundColor = '#EAB308' }}
                onMouseLeave={(e) => { if (!busy) e.target.style.backgroundColor = '#FACC15' }}
              >
                {busy ? 'Sending…' : 'Send reset link'}
              </button>

              <p style={{ textAlign: 'center', margin: 0 }}>
                <Link
                  to="/login"
                  style={{ color: '#9ca3af', fontSize: '14px', textDecoration: 'none' }}
                >
                  Back to sign in
                </Link>
              </p>
            </form>
          </>
        )}
      </div>
    </div>
  )
}
